<template>
  <div class="static-sidebar-wrapper sidebar-blue">
    <div class="static-sidebar">
      <div class="sidebar">
        <div class="widget" id="widget-profileinfo">
          <div class="widget-body">
            <div class="userinfo">
              <div class="avatar pull-left">
                <img
                  v-bind:src="this.avatar"
                  class="img-responsive img-circle"
                />
              </div>
              <div class="info">
                <span class="username">{{
                  this.$store.state.common.username
                }}</span>
              </div>
              <div class="acct-dropdown clearfix dropdown">
                <span class="pull-left"
                  ><span class="online-status online"></span>Online</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="widget stay-on-collapse" id="widget-sidebar">
          <nav role="navigation" class="widget-body">
            <ul class="acc-menu">
              <li>
                <router-link to="/admin" exact class="withripple">
                  <span class="icon"><i class="material-icons">dashboard</i></span>
                  <span>Dashboard</span>
                </router-link>
              </li>
              <li v-if="organisationSetupMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">corporate_fare</i></span
                  ><span>Organization Set up</span></a
                >
                <ul class="acc-menu iconout">
                  <li v-for="item in organisationBoundView" :key="item.id">
                    <router-link :to="{path:item.url}"
                      ><span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}</router-link
                    >
                   
                  </li>

                </ul>
              </li>
            <!-- Profiling -->
             <li v-if="UserDetailMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">corporate_fare</i></span
                  ><span>User Details</span></a
                >
                <ul class="acc-menu iconout">
                  <li v-for="item in UserDetailMenu" :key="item.id">
                    <router-link :to="{path:item.url}"
                      ><span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}</router-link
                    >
                  </li>
                </ul>
              </li>
            <!-- Profiling End -->
                <!-- Channel Partner -->
                <li v-if="channelPartnerMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">polymer</i></span
                  ><span>Channel Partner</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in channelPartnerBoundView" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                </ul>
              </li>
                
             
                <!-- Channel Partner / -->
                 <!-- Service Partner -->
              <li v-if="servicePartnerMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">group_work</i></span
                  ><span>Service Partner</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in servicePartnerBoundView" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                </ul>
              </li>
                  
                
                <!-- Service Partner / -->
             

              <!-- Enquery Leads -->
              
              <li v-if="leadsMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">person</i></span
                  ><span>Leads</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in leadsMenu" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                </ul>
              </li>
              <!-- Enquery Leads / -->
               <!-- Loyalty Menu -->
               <li v-if="LoyaltyMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">loyalty</i></span
                  ><span>Loyalty</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in loyaltyBoundView" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                </ul>
              </li>
               <!-- Loyalty Menu / -->
               <!-- Loyalty Menu -->
               <li v-if="LoyaltyCustomerMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">loyalty</i></span
                  ><span>Loyalty</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in LoyaltyCustomerBoundView" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                </ul>
              </li>
               <!-- Loyalty Menu / -->
               <!-- Payment Menu -->
               <li v-if="PaymentMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">person</i></span
                  ><span>Payment</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in PaymentBoundView" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                </ul>
              </li>
               <!-- Payment Menu / -->
                <!-- Report Menu -->
               <li v-if="ReportMenu.length">
                <a class="withripple" href="javascript:;"
                  ><span class="icon"><i class="material-icons">person</i></span
                  ><span>Reports</span></a
                >
                <ul class="acc-menu iconout">
                 <li v-for="item in ReportBoundView" :key="item.id">
                    <router-link :to="{path:item.url}">
                      <span class="icon"
                        ><i class="material-icons">{{item.icon}}</i></span
                      >{{item.menu}}
                    </router-link>
                  </li>
                  <!-- Direct static entry for Invalid Coupons -->
                  <li>
                    <router-link to="/reportInvalidCoupons">
                      <span class="icon">
                        <i class="material-icons">block</i>
                      </span>
                      Invalid Coupons
                    </router-link>
                  </li>
                  <!-- Static entry for Coupon Scan -->
                  <!-- Removed duplicate Coupon Scan menu item -->
                  <li>
                    <router-link to="/Report/couponsScan">
                      <span class="icon">
                        <i class="material-icons">qr_code_scanner</i>
                      </span>
                      Coupon Scan
                    </router-link>
                  </li>
                </ul>
              </li>
               <!-- Report Menu / -->
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import commonServices from '../../services/common-services'
import { AbilityBuilder } from '@casl/ability'
import _ from 'lodash';
export default {
  name: 'side-bar',
  data(){
    return {
      PermissionData:[],
      menuList:[],
      leadsMenu:[],
      organisationSetupMenu:[],
      organisationUserMenu:[],
      channelPartnerMenu:[],
      servicePartnerMenu:[],
      LoyaltyMenu:[],
      LoyaltyCustomerMenu:[],
      UserDetailMenu:[],
      PaymentMenu:[],
      ReportMenu:[],
    }
  },
  computed:{
    avatar(){
      return commonServices.local_asset_url('assets/demo/avatar/avatar_15.png')
    },
    organisationBoundView: function(){
      let self =this;
      return _.pickBy(this.organisationSetupMenu, function(d) {
        return self.$can(d.boundCheck,d.bound);
      });
    },
    channelPartnerBoundView: function(){
      let self =this;
      return _.pickBy(this.channelPartnerMenu, function(d) {
        return self.$can(d.boundCheck,d.bound);
      });
    },
    servicePartnerBoundView: function(){
      let self = this;
      return _.pickBy(this.servicePartnerMenu, function(d) {
        if (d.url === '/allServicePartners') {
          return self.$can('View', 'ServicePartner::Reborer') ||
                 self.$can('View', 'ServicePartner::Mechanic') ||
                 self.$can('View', 'ServicePartner::Grinder') ||
                 self.$can('View', 'ServicePartner::Grinder Reborer') ||
                 self.$can(d.boundCheck, d.bound);
        }
        return self.$can(d.boundCheck, d.bound);
      });
    },
    loyaltyBoundView: function(){
      let self =this;
      return _.pickBy(this.LoyaltyMenu, function(d) {
        return self.$can(d.boundCheck,d.bound);
      });
    },
    PaymentBoundView: function(){
      let self =this;
      return _.pickBy(this.PaymentMenu, function(d) {
        return self.$can(d.boundCheck,d.bound);
      });
    },
    ReportBoundView: function(){
      let self = this;
      // Remove duplicates by menu and url
      const seen = new Set();
      return Object.values(_.pickBy(this.ReportMenu, function(d) {
        return self.$can(d.boundCheck, d.bound);
      })).filter(item => {
        const key = item.menu + '|' + item.url;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    },
    LoyaltyCustomerBoundView: function(){
      let self = this;
      return _.pickBy(this.LoyaltyCustomerMenu, function(d) {
        return self.$can(d.boundCheck,d.bound);
      });
    },
     
  },
  created(){
    const { can, rules } = new AbilityBuilder();
    let PermissionData = this.$store.state.common.MyPermission;
    PermissionData.forEach(element => {
        can(element.action, element.subject);
      });
      this.$ability.update(rules);
  },
  mounted(){
    this.menuList = this.$store.state.common.globalmenues
    this.menuList.forEach(element => {
      if(element.parent === 'leads'){
        this.leadsMenu.push(element)
      }
      if(element.parent === 'organisationSetup'){
        this.organisationSetupMenu.push(element)
      }
      if(element.parent === 'UserDetail'){
        this.UserDetailMenu.push(element)
      }
      if(element.parent === 'ChannelPartnerType'){
        this.channelPartnerMenu.push(element)
      }
      if(element.parent === 'ServicePartnerType'){
        this.servicePartnerMenu.push(element)
      }
       if(element.parent === 'Loyalty'){
        this.LoyaltyMenu.push(element)
      }
      if(element.parent === 'LoyaltyCustomer'){
        this.LoyaltyCustomerMenu.push(element)
      }
      if(element.parent === 'Payment'){
        this.PaymentMenu.push(element)
      }
       if(element.parent === 'Report'){
        this.ReportMenu.push(element)
      }
      
    });
    // Ensure "All Service Partners" is present at the beginning of servicePartnerMenu if missing
    if (this.servicePartnerMenu.length > 0 && !this.servicePartnerMenu.some(m => m.url === '/allServicePartners')) {
      this.servicePartnerMenu.unshift({
        parent: 'ServicePartnerType',
        bound: 'ServicePartner::Reborer',
        boundCheck: 'View',
        menu: 'All Service Partners',
        url: '/allServicePartners',
        icon: 'vignette'
      });
    }
    this.$nextTick(() => {
      this.syncActiveMenu();
    });
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.syncActiveMenu();
      }
    }
  },
  methods: {
    syncActiveMenu() {
      this.$nextTick(() => {
        if (typeof $ !== 'undefined') {
          // Remove stuck active class from all menu items
          $('ul.acc-menu li').removeClass('active');

          // Highlight the item matching current route
          var activeExact = $('ul.acc-menu a.router-link-exact-active');
          if (activeExact.length) {
            activeExact.closest('li').addClass('active');
            activeExact.parents('li').addClass('open');
            activeExact.parents('ul.acc-menu').show();
          } else {
            var currentPath = this.$route ? this.$route.path : '';
            var activeLink = $('ul.acc-menu a').filter(function() {
              var href = $(this).attr('href');
              return href && href !== '/admin' && href !== '/' && currentPath && currentPath.indexOf(href) === 0;
            });
            if (activeLink.length) {
              activeLink.first().closest('li').addClass('active');
              activeLink.parents('li').addClass('open');
              activeLink.parents('ul.acc-menu').show();
            }
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.sidebar nav.widget-body > ul.acc-menu li.open > a,
.sidebar nav.widget-body > ul.acc-menu li.active > a,
.sidebar nav.widget-body > ul.acc-menu li.open > a span,
.sidebar nav.widget-body > ul.acc-menu li.active > a span,
.sidebar nav.widget-body > ul.acc-menu li.open > a i,
.sidebar nav.widget-body > ul.acc-menu li.active > a i,
.sidebar-blue nav.widget-body > ul.acc-menu li.open > a,
.sidebar-blue nav.widget-body > ul.acc-menu li.active > a,
.sidebar-blue nav.widget-body > ul.acc-menu li.open > a span,
.sidebar-blue nav.widget-body > ul.acc-menu li.active > a span,
.sidebar-blue nav.widget-body > ul.acc-menu li.open > a i,
.sidebar-blue nav.widget-body > ul.acc-menu li.active > a i,
.sidebar-blue nav.widget-body > ul.acc-menu > li.open > a > span.icon,
.sidebar-blue nav.widget-body > ul.acc-menu > li.active > a > span.icon {
  color: #ffffff !important;
}

/* Inactive menu items return to default unselected styling */
.sidebar-blue nav.widget-body > ul.acc-menu > li:not(.active):not(.open):not(:hover) > a {
  background-color: #d7d7d7 !important;
  color: #424242 !important;
}
.sidebar-blue nav.widget-body > ul.acc-menu > li:not(.active):not(.open):not(:hover) > a span.icon,
.sidebar-blue nav.widget-body > ul.acc-menu > li:not(.active):not(.open):not(:hover) > a i {
  color: #6b6a6a !important;
}
</style>
